<template>
    <Card :header="$t('productLandingPage2')">
        <p>{{ $t('useTheLinkBelowInYourSocialMediaMailingsEtc') }}</p>
        <b-link :href="helperUrl" target="_blank">{{ $t('learnMoreAboutHowToUseTheProductLanding') }}</b-link>
        <div class="d-flex flex-column justify-content-center align-items-center flex-grow-1 overflow-hidden my-3">
            <WidgetPreview
                v-if="plugin && product"
                :key="product?.id"
                ref="WidgetPreview"
                :bb-id="plugin.id"
                :bb-number="Number.parseInt(product.ean)"
                :bb-name="product.name"
                class="height-min-40"
                :class="{ 'w-100': !widgetLoading }"
                @BBLoading="widgetLoading = true"
                @NoData="widgetLoading = false"
                @BBLoaded="widgetLoading = false"
            />
            <b-spinner v-if="widgetLoading" class="m-auto" />
        </div>
        <div class="d-flex gap-3 mt-3">
            <ButtonIcon variant="primary" icon="copy" :disabled="!widgetLink" @click="copyWidgetLink()">{{ $t('copyLink') }}</ButtonIcon>
            <ButtonIcon variant="primary" icon="external-link" :disabled="!widgetLink" :href="widgetLink" target="_blank">{{ $t('openLink') }}</ButtonIcon>
        </div>
    </Card>
</template>



<script>
    import WidgetPreview from '@/components/common/WidgetPreview.vue';

    export default {
        name: 'ProductLandingPage',
        components: {
            WidgetPreview,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestPlugin: this.parentComponent.requestPlugin,
                widgetLoading: false,
            };
        },
        computed: {
            plugin() {
                return this.requestPlugin.getData();
            },
            spaceId() {
                return this.parentComponent.spaceId;
            },
            product() {
                return this.parentComponent.product;
            },
            widgetLink() {
                if (!this.plugin?.id || !this.product?.ean) return '';
                return encodeURI(`${process.env.VUE_APP_WIDGET_PREVIEW_URL}?id=${this.plugin.id}&number=${this.product.ean}&name=${this.product.name}`);
            },
            helperUrl() {
                return 'https://docs.100shoppers.com/jak-wykorzystac-landing-page-produktowy/';
            },
        },
        methods: {
            async copyWidgetLink() {
                await this.$copyText(this.widgetLink);
                this.$toastr.success(this.$t('widgetLinkCopiedSuccessful'));
            },
        },
    };
</script>



<style lang="scss" scoped>
    ::v-deep {
        #bb-widget-preview {
            .bb-alt.bb-shown {
                font-size: 20px;
            }
        }
    }
</style>
